export const TITLE_APP = {
  HOME: 'Home',
  PROFILE: 'Profile',
  REPORTS: 'Reports',
  ONBOARDING: 'Onboarding',
  SCHEME_ANALYTICS: 'Scheme Analytics',
  SCHEME_DETAILS: 'Scheme Details',
  TRANSACTION: 'Transaction',
  REDEMPTION: 'Redeem',
  MANDATE: 'Mandate',
  SIGN_UP: 'Sign Up',
  FORGET_PASSWORD: 'Forget Password',
  RISK_PROFILE: 'Risk Profile',
  REVIEW_REQUEST: 'Review Request',
  BROKER_LIST: 'Brokers',
  RM_LIST: 'Relationship Managers',
  TRANSACTION_HISTORY: 'Transaction History',
  CLIENTS: 'Clients',
  ADVISOR_LIST: 'Advisor List',
  UCC_LIST: 'UCC List'
};
